export function getEmployeeInfo(employee) {
    let dateText = " ";
    let date = " ";
    let popup = "No info available";

   
    if (employee.employeeStatus === "CURRENT") {
        dateText = "Employed: ";
        date = employee.dates.dateStarted;
        popup = "Current employee";
    } else if (employee.employeeStatus === "EX") {
        dateText = "Let go: ";
        date = employee.dates.dateEnded;
        popup = "Ex-employee";
    }

    return [dateText, date, popup];

}